export const clientGroupSourceDeleteResponse = () => ({
  clientGroupSourceDelete: {
    status: true,
    // @ts-ignore
    __typename: 'Status',
  },
});
